var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeutralsmile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3121_61492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 24C9.86883 24 0 33.8688 0 46C0 58.1312 9.86883 68 22 68C34.1312 68 44 58.1312 44 46C44 33.8688 34.1312 24 22 24ZM9.16667 42.3333C9.16667 41.3195 9.988 40.5 11 40.5H16.5C17.512 40.5 18.3333 41.3195 18.3333 42.3333C18.3333 43.3472 17.512 44.1667 16.5 44.1667H11C9.988 44.1667 9.16667 43.3472 9.16667 42.3333ZM31.1667 55.1667H12.8333C11.8213 55.1667 11 54.3472 11 53.3333C11 52.3195 11.8213 51.5 12.8333 51.5H31.1667C32.1787 51.5 33 52.3195 33 53.3333C33 54.3472 32.1787 55.1667 31.1667 55.1667ZM33 44.1667H27.5C26.488 44.1667 25.6667 43.3472 25.6667 42.3333C25.6667 41.3195 26.488 40.5 27.5 40.5H33C34.012 40.5 34.8333 41.3195 34.8333 42.3333C34.8333 43.3472 34.012 44.1667 33 44.1667Z",
    fill: "#5196FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3121_61492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(0 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralsmile);
export default __webpack_public_path__ + "static/media/neutralsmile.1d504a1829f9dd4596b3ec2262515a12.svg";
export { ForwardRef as ReactComponent };